"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowHideButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Anchor = require("../Anchor/Anchor");
var _IconChevronDown = _interopRequireDefault(require("../Icon/icons/IconChevronDown"));
var _IconChevronUp = _interopRequireDefault(require("../Icon/icons/IconChevronUp"));
var _TextButton = require("../TextButton/TextButton");
var _excluded = ["appearance", "isHidden", "children"];
/**
 * `ShowHideButton` is the default button used by the `ShowHide` component.
 *
 * @extends TextButton
 * @since 8.36.0
 */
var ShowHideButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var appearance = _ref.appearance,
    isHidden = _ref.isHidden,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (appearance === 'inline') {
    return /*#__PURE__*/_react.default.createElement(_Anchor.Anchor, (0, _extends2.default)({
      as: "button",
      ref: forwardedRef,
      "aria-expanded": !isHidden
    }, rest), children);
  }
  var icon = /*#__PURE__*/_react.default.createElement(_IconChevronUp.default, null);
  if (isHidden) {
    icon = /*#__PURE__*/_react.default.createElement(_IconChevronDown.default, null);
  }
  return /*#__PURE__*/_react.default.createElement(_TextButton.TextButton, (0, _extends2.default)({
    ref: forwardedRef,
    icon: icon,
    "aria-expanded": !isHidden,
    iconSize: "xs"
  }, rest), children);
});
exports.ShowHideButton = ShowHideButton;
ShowHideButton.displayName = 'ShowHideButton';
ShowHideButton.propTypes = process.env.NODE_ENV !== "production" ? {
  appearance: _propTypes.default.oneOf(['inline', 'block']).isRequired,
  isHidden: _propTypes.default.bool,
  children: _propTypes.default.node
} : {};